import {Avatar, Button, Icon, Input, message, Select, Table, Tag} from 'antd';
import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';
import Card, {CardBody, CardHeader} from '../../components/Card';
import Flex from '../../components/Flex';
import Layout, {Main} from '../../components/Layout';
import {RolesListModelType} from '../../models/RolesListModel';
import {UsersListModelType} from '../../models/UsersListModel';
// tslint:disable
const Search = Input.Search;
const Option = Select.Option;

interface WithInjectedProps {
  usersList: UsersListModelType;
  rolesList: RolesListModelType;
}

interface UsersState {
  filterByField: 'email' | 'name' | 'id';
  inputUserIdVisible: boolean;
  userIds: number[];
  inputTeamIdVisible: boolean;
  teamIds: number[];
  roleId?: number;
  inputUserIdValue: string;
  inputTeamIdValue: string;
}

@inject('usersList', 'rolesList')
@observer
class Users extends React.Component<{}, UsersState> {
  constructor(props: any) {
    super(props);
    this.state = {
      filterByField: 'email',
      inputUserIdVisible: false,
      inputTeamIdVisible: false,
      inputUserIdValue: '',
      inputTeamIdValue: '',
      userIds: [],
      teamIds: [],
      roleId: undefined
    };
  }

  componentDidMount() {
    this._loadData({limit: 12, offset: 0});
  }

  private _handleAssignUser = () => {
    const {userIds, teamIds, roleId} = this.state;

    if (userIds.length === 0 || teamIds.length === 0 || !roleId) {
      message.error('Please fill in all fields: User ID, Role, Team Id');
    }

    this.withInjectedProps.usersList.bulkAssignUser(userIds, teamIds, roleId!);
    message.success('Bulk assign successfully');
  };

  private renderBulkAssign() {
    const {entries: roleEntries} = this.withInjectedProps.rolesList;
    const {isLoading} = this.withInjectedProps.usersList;
    const roleArray = Array.from(roleEntries.values());
    return (
      <Flex
        justify="space-between"
        style={{border: '1px solid gray', padding: 10}}
      >
        <Flex>
          {this.state.userIds.map((value, idx) => {
            return <Tag key={idx}>{value}</Tag>;
          })}

          {this.state.inputUserIdVisible && (
            <Input
              type="text"
              size="small"
              style={{width: 78}}
              value={this.state.inputUserIdValue}
              onChange={this._handleUserIdChange}
              onBlur={this._handleUserIdConfirm}
              onPressEnter={this._handleUserIdConfirm}
            />
          )}

          {!this.state.inputUserIdVisible && (
            <Tag
              onClick={this._showInputUserId}
              style={{background: '#fff', borderStyle: 'dashed'}}
            >
              <Icon type="plus" /> New User Id
            </Tag>
          )}
        </Flex>
        <Select
          style={{width: '20%'}}
          placeholder="Role"
          onChange={value => {
            this.setState({roleId: Number(value)});
          }}
        >
          {roleArray.map((role, idx) => {
            return (
              <Option key={String(idx)} value={role.id}>
                {role.name}
              </Option>
            );
          })}
        </Select>

        <Flex>
          {this.state.teamIds.map((value, idx) => {
            return <Tag key={idx}>{value}</Tag>;
          })}

          {this.state.inputTeamIdVisible && (
            <Input
              type="text"
              size="small"
              style={{width: 78}}
              value={this.state.inputTeamIdValue}
              onChange={this._handleTeamIdChange}
              onBlur={this._handleTeamIdConfirm}
              onPressEnter={this._handleTeamIdConfirm}
            />
          )}
          {!this.state.inputTeamIdVisible && (
            <Tag
              onClick={this._showInputTeamId}
              style={{background: '#fff', borderStyle: 'dashed'}}
            >
              <Icon type="plus" /> New Team Id
            </Tag>
          )}
        </Flex>
        <Button
          type="primary"
          loading={isLoading}
          onClick={this._handleAssignUser}
        >
          Assign
        </Button>
      </Flex>
    );
  }

  handleFilterFieldSelect = (field: string) => {
    if (field === 'email' || field === 'name' || field === 'id') {
      this.setState({filterByField: field});
    }
  };

  render() {
    const columns = this._getColumnsTable();
    const {entries, isLoading, pagination} = this.withInjectedProps.usersList;
    const dataSource = this._cvtDataSource(Array.from(entries.values()));
    return (
      <React.Fragment>
        <Helmet>
          <title>Manage Users</title>
        </Helmet>
        <Layout>
          <Main>
            <Card style={{marginBottom: 10}}>
              <CardHeader>Bulk Assign User</CardHeader>
              <CardBody>{this.renderBulkAssign()}</CardBody>
            </Card>
            <Card>
              <CardHeader>Manage Users</CardHeader>
              <CardBody>
                <h3>Users</h3>
                <Flex justify="flex-end" style={{marginBottom: 16}}>
                  <Select
                    style={{flexBasis: 120}}
                    onSelect={this.handleFilterFieldSelect}
                    defaultValue="email"
                  >
                    <Select.Option title="By email" value="email">
                      By email
                    </Select.Option>
                    <Select.Option title="By name" value="name">
                      By name
                    </Select.Option>
                    <Select.Option title="By ID" value="id">
                      By id
                    </Select.Option>
                  </Select>
                  <Search
                    placeholder={`Enter ${this.state.filterByField}`}
                    onSearch={value => this.onSearchUsers(value)}
                    allowClear={true}
                    style={{width: 300}}
                  />
                </Flex>
                <Table
                  dataSource={dataSource}
                  columns={columns}
                  loading={isLoading}
                  onChange={this._handleDataTableChange}
                  pagination={{
                    pageSize: pagination.limit,
                    current: pagination.current,
                    total: pagination.total
                  }}
                />
              </CardBody>
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }
  private _handleTeamIdChange = (event: any) => {
    const value = event.target.value;
    this.setState({inputTeamIdValue: value.trim()});
  };

  private _handleTeamIdConfirm = () => {
    let {inputTeamIdValue, teamIds} = this.state;
    let teamId = Number(inputTeamIdValue);
    if (inputTeamIdValue && teamIds.indexOf(teamId) === -1) {
      teamIds = [...teamIds, teamId];
    }
    this.setState({
      teamIds: teamIds,
      inputTeamIdValue: '',
      inputTeamIdVisible: false
    });
  };

  private _handleUserIdChange = (event: any) => {
    const value = event.target.value;
    this.setState({inputUserIdValue: value.trim()});
  };

  private _handleUserIdConfirm = () => {
    let {inputUserIdValue, userIds} = this.state;
    let userId = Number(inputUserIdValue);
    if (inputUserIdValue && userIds.indexOf(userId) === -1) {
      userIds = [...userIds, userId];
    }
    this.setState({
      userIds: userIds,
      inputUserIdValue: '',
      inputUserIdVisible: false
    });
  };

  private _showInputUserId = () => {
    this.setState({inputUserIdVisible: true});
  };

  private _showInputTeamId = () => {
    this.setState({inputTeamIdVisible: true});
  };

  private _handleDataTableChange = (
    pagination: any,
    filters: any,
    sorter: any
  ) => {
    // const pager = this.withInjectedProps.teamsList.pagination;
    const {pageSize, current} = pagination;
    this._loadData({limit: pageSize, offset: pageSize * (current - 1)});
  };

  private onSearchUsers(value: string) {
    const params = {
      limit: 12,
      offset: 0,
      ...(value && {
        [this.state.filterByField]: value.trim().toLowerCase()
      })
    };
    this.withInjectedProps.usersList.clearEntries();
    this._loadData(params);
  }

  private _cvtDataSource(entries: any) {
    return entries.map((item: any, idx: number) => {
      return this._userItemData(item);
    });
  }

  private _userItemData(item: any) {
    return {
      key: item.id,
      id: item.id,
      avatar: <Avatar shape="square" src={item.avatar} />,
      name: `${item.firstName} ${item.lastName ? item.lastName : ''}`,
      email: item.email,
      phone: item.phone,
      location: item.location,
      slackThreadId: item.slackThreadId,
      role: item.role ? item.role.name : 'Not Found',
      actions: <Link to={`/users/${item.id}`}>Details</Link>
    };
  }

  private _loadData(params: any) {
    this.withInjectedProps.usersList.loadEntries(params);
    this.withInjectedProps.rolesList.loadEntries('team');
  }

  private _getColumnsTable() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email'
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone'
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location'
      },
      {
        title: 'Slack Thread Id',
        dataIndex: 'slackThreadId',
        key: 'slackThreadId'
      },
      {
        title: 'Role',
        dataIndex: 'role',
        key: 'role'
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions'
      }
    ];
  }
  get withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/pages/Users/Users.tsx